import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

import FormValidator from '../../lib/FormValidator';

import { alertAdd } from '../../store/actions/alert';
import { setDirty } from '../../store/actions/form';

import DirtyModal from '../../components/Modals/DirtyModal/DirtyModal';
import ErrorModal from '../../components/Modals/ErrorModal/ErrorModal';

import * as constants from '../../constants';

const withForm = (WrappedComponent, validationRules) => {
    class HOC extends Component {
        state = {
            showDirtyModal: false,
            showErrorModal: false,
            validations: null,
            isValidated: false,
            errorMessage: ''
        };

        changedHandler = (id, value) => {      
            this.props.onSetDirty(true);

            this.setState({ isValidated: false });

            if (this.props.changed) {
                this.props.changed(id, value);
            }
        };

        noDirtyClicked = () => {
            this.setState({ showDirtyModal: false });
        };

        noErrorClicked = () => {
            this.setState({ showErrorModal: false, errorMessage: '' }, () => {
                if (this.props.errorClosed) {
                    this.props.errorClosed();
                }
            });
        };
    
        yesDirtyClicked = () => {
            this.props.onSetDirty(false);
            this.setState({ showDirtyModal: false });

            if (this.props.cancelled) {
                this.props.cancelled();
            }
        };
    
        cancelledHandler = (data) => {  
            const showModal = (data === undefined || !data.ignoreDirty);

            if (this.props.isDirty && showModal) {
                this.setState({ showDirtyModal: true });
            } else {
                if (this.props.cancelled) {
                    this.props.cancelled();
                }          
            }
        };

        submittedHandler = (data) => {
            this.props.onSetDirty(false);
            this.setState({ showDirtyModal: false });

            if (this.props.submitted) {
                this.props.submitted(data);
            }
        };

        validateHandler = (values, dynamicRules) => {
            this.setState({ validations: null, isValidated: false });

            const rules = (dynamicRules) ? dynamicRules : validationRules;

            const validations = new FormValidator(rules).validate(values);

            this.setState({ validations: validations, isValidated: validations.isValid });  
        };

        validationResetHandler = () => {
            this.setState({ validations: null, isValidated: false });
        };

        validationCheckHandler = (id) => {
            if (!_.isEmpty(this.state.validations) && !this.state.validations.isInvalid) {
                if (this.state.validations[id] && this.state.validations[id].isInvalid) {
                    return this.state.validations[id].message;
                }
            }

            return null;
        };

        alertFailHandler = (alertText) => {
            this.props.onAlertAdd({ key: constants.ALERT_NOTE_FAIL, text: alertText, type: constants.ALERT_TYPE_DANGER });
            if(alertText){
                this.setState({ errorMessage: alertText });
                this.setState({ showErrorModal: true });
            }
        };

        alertSuccessHandler = (alertText) => {
            this.props.onAlertAdd({
                key: constants.ALERT_NOTE_SAVE,
                text: alertText
            });
        };

        render() {
            return (
                <React.Fragment>
                    <DirtyModal show={this.state.showDirtyModal}
                        noClick={this.noDirtyClicked}
                        yesClick={this.yesDirtyClicked} />

                    <ErrorModal show={this.state.showErrorModal && !_.isEmpty(this.state.errorMessage)}
                        noClick={this.noErrorClicked}
                        message={this.state.errorMessage}
                        />

                    <WrappedComponent {...this.props}
                        isValidated={this.state.isValidated}
                        validations={this.state.validations}
                        formChanged={this.changedHandler}
                        formCancelled={this.cancelledHandler}
                        formSubmitted={this.submittedHandler}
                        formValidate={this.validateHandler}
                        formValidationCheck={this.validationCheckHandler}
                        formAlertFail={this.alertFailHandler}
                        formAlertSuccess={this.alertSuccessHandler}
                        formValidationReset={this.validationResetHandler} />
                </React.Fragment>
            );
        }
    };

    const mapStateToProps = (state) => ({
        isDirty: state.form.isDirty
    });

    const mapDispatchToProps = (dispatch) => ({
        onSetDirty: (isDirty) => dispatch(setDirty(isDirty)),
        onAlertAdd: (alert) => dispatch(alertAdd(alert))
    });

    return connect(mapStateToProps, mapDispatchToProps)(HOC);
};

export default withForm;
